import { render, staticRenderFns } from "./CustomerGroupHistoryValuesTable.vue?vue&type=template&id=20805193"
import script from "./CustomerGroupHistoryValuesTable.vue?vue&type=script&lang=js"
export * from "./CustomerGroupHistoryValuesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports